var s = /* @__PURE__ */ ((i) => (i.ANONYMOUS = "Anonymous", i.ABO = "BUSINESS_OWNER", i.REGISTERED = "CUSTOMER", i.MEMBER = "MEMBER", i.EMPLOYEE = "EMPLOYEE", i))(s || {});
const l = function(i, e) {
  let o = {};
  if (i)
    if (i.SessionService)
      ({ SessionService: o } = i);
    else
      return i.SessionService = o, e(o);
  return o;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(i) {
    let e = {};
    const o = () => ({
      session: e,
      isAnonymous: () => !(e != null && e.type) || (e == null ? void 0 : e.type) === s.ANONYMOUS,
      isRegistered: () => (e == null ? void 0 : e.type) === s.REGISTERED,
      isABO: () => (e == null ? void 0 : e.type) === s.ABO,
      isMember: () => (e == null ? void 0 : e.type) === s.MEMBER,
      isEmployee: () => (e == null ? void 0 : e.type) === s.EMPLOYEE,
      isActor: () => !!e.act
    }), n = (t) => {
      e = Object.assign(e, t);
    };
    return i.getSession = o, i.setSession = n, i;
  }
);
export {
  l as A
};
//# sourceMappingURL=SessionService-cbb226e7.mjs.map
